/**
 * Whether a section's title still needs writing in `lang`: blank, or just the
 * English copied in. The backend refuses to save a section in that state
 * (content team, 28 Oct 2026 — every language needs its own title), after
 * first trying to translate the missing ones from English itself.
 */
export const titleMissing = (lang, value, english) => {
  const title = String(value ?? "").trim();
  if (!title) return true;
  return lang !== "en" && title.toLowerCase() === String(english ?? "").trim().toLowerCase();
};

export const TITLE_HINT =
  "Type the English title — the other languages are translated automatically on save, and you can edit any of them by hand. " +
  "A dot marks a language that is empty or still in English: every language needs its own title, so a save that can't fill one is refused.";
